// =====================================================================
// prescriptionService (Receituário / S55) — chamadas axios pra API do
// receituário do médico (biblioteca de fórmulas/medicamentos do EHR).
//
// Endpoints (todos isAuth no backend; multi-tenant por companyId do JWT):
//   GET    /prescription-items?professionalId=&search=&includeShared=  -> { items, count }
//   POST   /prescription-items            -> item criado
//   POST   /prescription-items/bulk       -> { created } (import em massa)
//   PUT    /prescription-items/:id        -> atualizado
//   DELETE /prescription-items/:id        -> 204
// =====================================================================
import api from "./api";

export const listPrescriptionItems = async ({
  professionalId,
  search,
  includeShared = true,
  onlyActive = true
} = {}) => {
  const params = {};
  if (professionalId !== undefined && professionalId !== null && professionalId !== "") {
    params.professionalId = professionalId;
  }
  if (search) params.search = search;
  if (!includeShared) params.includeShared = "false";
  if (!onlyActive) params.onlyActive = "false";
  const { data } = await api.get("/prescription-items", { params });
  return data; // { items, count }
};

export const createPrescriptionItem = async (payload) => {
  const { data } = await api.post("/prescription-items", payload);
  return data;
};

export const updatePrescriptionItem = async (id, payload) => {
  const { data } = await api.put(`/prescription-items/${id}`, payload);
  return data;
};

export const deletePrescriptionItem = async (id) => {
  await api.delete(`/prescription-items/${id}`);
};

// payload: { professionalId, folder, items: [{ displayName, shortName?, posology?, folder? }] }
export const bulkCreatePrescriptionItems = async (payload) => {
  const { data } = await api.post("/prescription-items/bulk", payload);
  return data; // { created }
};

// Traduz o erro do backend (AppError -> { error: "ERR_..." }) numa msg amigável.
export const prescriptionErrorMessage = (err) => {
  const code = err && err.response && err.response.data && err.response.data.error;
  const map = {
    ERR_PRESCRIPTION_NAME_REQUIRED: "Informe o nome do item.",
    ERR_PRESCRIPTION_NOT_FOUND: "Item não encontrado.",
    ERR_PRESCRIPTION_BULK_EMPTY: "Nenhum item válido pra importar."
  };
  if (code && map[code]) return map[code];
  if (code && typeof code === "string" && !code.startsWith("ERR_")) return code;
  return "Não foi possível concluir a operação. Tente novamente.";
};
